import React, {Component} from 'react';
import {
  Input,
  Select,
  message,
  Table
} from 'antd';
import './delivery.css';
import Data from '../../../utils/expressData.js';

const Option = Select.Option;
class sendDelivery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expressData: Data.expressData,
      defaultValue: '',
      orderData: [],
      expno: ''
    };
  }
  componentWillMount() {
    //验证是否需要登录
    if (!window.common.loginOut(this)) {
      message.error('登录信息失效，请重新登录');
    }
    this.setState({orderData: this.props.orderData, defaultValue: this.props.expname, expno: this.props.expno});
  }
  componentWillReceiveProps(props) {
    this.setState({orderData: props.orderData, defaultValue: props.expname, expno: props.expno});
  }
  selExpressNameEvent = (value) => {
    this.setState({
      defaultValue: value
    });
    this.props.selExpressNameEvent(value);
  }
  orderNumberEvent = (e) => {
    this.setState({
      expno: e.target.value
    });
    this.props.orderNumberEvent(e.target.value);
  }
  checkGoodsEvent = (selectedRowKeys, selectedRows) => {
    this.props.checkGoodsEvent(selectedRowKeys, selectedRows);
  }
  render() {
    const columns = [
      {
        title: '商品名称',
        key: 'goods_name',
        dataIndex: '',
        render: (record) => (
          <span className="flex-blocks">
            <img src={record.goods_pic} className="img-ico" />
            {record.goods_name}
          </span>
        )
      },
      {
        title: '数量',
        key: 'goods_qty',
        dataIndex: 'goods_qty'
      },
      {
        title: '状态',
        key: 'status',
        dataIndex: 'status',
        render: (record) => (
          <span>待发货</span>
        )
      },
      {
        title: '运单号',
        key: 'express_no',
        dataIndex: 'express_no'
      }
    ];
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.checkGoodsEvent(selectedRowKeys, selectedRows);
      },
      getCheckboxProps: record => ({
        disabled: record.express_no !== null, // Column configuration not to be checked
        name: record.express_no,
      }),
    };
    const orderData = this.state.orderData || {};
    return (
      <div className="delivery-blocks send-delivery-wrap">
        <ul className="express-items">
          <li className="express-items__hint">选择商品（待发货可勾选，已发货不可选）</li>
          <li>
            <Table
              rowSelection={rowSelection}
              columns={columns}
              dataSource={(this.state.orderData && this.state.orderData.order_details) || []}
              className="table-box"
              rowKey={record => record.id}
              hideOnSinglePage="true"
              size="small"
            />
          </li>
          <li className="express-items__section">
            <h2 className="express-items__title">配送信息</h2>
            <div className="express-items__row"><span className="express-items__label">收货人</span><span className="express-items__value">{orderData.receiver || '—'} {orderData.mobile || ''}</span></div>
            <div className="express-items__row"><span className="express-items__label">收货地址</span><span className="express-items__value">{[orderData.province, orderData.city, orderData.area, orderData.address].filter(Boolean).join(' ')} {orderData.post_code || ''}</span></div>
          </li>
          <li className="express-items__section">
            <h2 className="express-items__title">发货方式</h2>
            <div className="flex-blocks">
              <label className="express-items__label">快递名称</label>
              <Select placeholder="请选择快递" value={this.state.defaultValue || undefined} onChange={this.selExpressNameEvent} className="express-items__input">
                {this.state.expressData.map((item, index) => <Option key={item.express_name || index} value={item.express_name}>{item.express_name}</Option>)}
              </Select>
            </div>
            <div className="flex-blocks">
              <label className="express-items__label">快递单号</label>
              <Input placeholder="请输入快递单号" onChange={this.orderNumberEvent} value={this.state.expno} className="express-items__input" allowClear />
            </div>
          </li>
          <li className="express-items__tip">
            <p className="red">说明：软件商品可不填写快递信息</p>
          </li>
        </ul>
      </div>
    );
  }
}
export default sendDelivery;



// WEBPACK FOOTER //
// ./src/containers/backEnd/deliveryMangement/sendDelivery.jsx